<template>
  <div>
  <floating-menu :event-id="eventId"></floating-menu>
  <b-row>
    <b-col cols="12">
      <event-participant-table />
    </b-col>
  </b-row>
</div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EventParticipantTable from './EventParticipantTable.vue'
import router from '@/router'
import FloatingMenu from './FloatingMenu.vue'


export default {
  components: {
    BRow,
    BCol,
    FloatingMenu,
    EventParticipantTable
  },
  data() {
    return {
      eventId: router.currentRoute.params.id,
    }
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>